import React, { useEffect, useState, useRef } from 'react';
import Overlay from '../../overlay-wrap/overlay-wrap';
import ScoreToolBlock from '../score-block/toolblock/toolblock';
import AdImage from '../../ad-image/ad-image';
import style from './warm-up-block-style.module.scss';
import DBHandler from '../../../javascript/index-db/db-handler.js';
import Clock from '../../clock/clock.js';
import { SPORT_BASE, NAV_CONTROL, GLOBAL_CSS } from '../../../javascript/services/globalVars.js';
import { genKeyRan, Wait_For_Auth } from '../../../javascript/utils/utils.js';
import useIsLandscape from '../../../javascript/utils/use-is-landscape.js';
import { is_push_match } from '../../../javascript/sport/sport-function';
import { useIsVisible } from 'react-is-visible';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { QrCodeTool } from "sme-util-module";
// import { API_CONTROL } from '../../../javascript/services/api-connection';
// import { build_sme_con } from '../../../javascript/services/auth';
import { SME_AUTH } from '../../../javascript/services/globalVars';
// import {  } from '../../../javascript/utils/utils';


const MID_RETRY_INTERVAL_MS = 1000;

const isValidMid = (mid) => {
   const parsed = parseInt(mid, 10);
   return !isNaN(parsed) && parsed > 0;
};

const buildReplayQrDetails = (mid, ccfg_id) => ({
   v: 1,
   action: "replay_permission",
   params: {
      mid: parseInt(mid, 10),
      ccfgId: ccfg_id,
   }
});


function WarmUpBlock(Props) {
   const isLandscape = useIsLandscape();
   const wrapper = useRef();
   const isVisible = useIsVisible(wrapper);

   let visibility = 0;
   if (typeof Props.visibility !== 'undefined') {
      visibility = Props.visibility;
   }

   const [btnList, setBtnList] = useState([]);
   const [sportSettings, setSportSettings] = useState([]);


   const [hasLocalAgent, setHasLocalAgent] = useState(false);
   const [qrDetails, setQrDetails] = useState(null);
   const [qrMatchId, setQrMatchId] = useState(null);
   const qrFetchCancelledRef = useRef(false);
   const qrFetchGenerationRef = useRef(0);

   const load_match = async (override = false) => {
      if (visibility === 1 || override === true) {
         const dbHandler = DBHandler();
         const app_state = await dbHandler.load_app_state();
         if (app_state.game_state === 'warmup') {
            // console.error('>>> load_match REAL: ', app_state.match_id);

            await SPORT_BASE.loadMatch(app_state.match_id);
            const settings = SPORT_BASE.sport_object.get_settings();
            const filtered_settings = SPORT_BASE.filterSettings(settings);
            setSportSettings(filtered_settings);
            setBtnList(SPORT_BASE.sport_object.warmup.tool_block);
         }
      }
   }

   const reset_qr_details = () => {
      qrFetchGenerationRef.current += 1;
      qrFetchCancelledRef.current = true;
      setQrDetails(null);
      setQrMatchId(null);
   }

   const get_qr_details = async () => {
      // console.log('>>> get_qr_details <<<');  // DON'T DELETE THIS LINE
      const fetchId = ++qrFetchGenerationRef.current;
      qrFetchCancelledRef.current = false;
      setQrDetails(null);
      setQrMatchId(null);

      const dbHandler = DBHandler();

      while (!qrFetchCancelledRef.current && fetchId === qrFetchGenerationRef.current) {
         const app_state = await dbHandler.load_app_state();
         const sync = await dbHandler.load_sync();
         const match = await dbHandler.loadMatch(app_state.match_id);

         // console.log('sync.ccfg_id: ', sync.ccfg_id);
         // console.log('>>>--- CHECK IF COURT HAS A LOCAL AGENT ---<<<');

         if (qrFetchCancelledRef.current || fetchId !== qrFetchGenerationRef.current) {
            return;
         }

         await Wait_For_Auth(SME_AUTH, true);
         const graphql = SME_AUTH.get_graphql();
         const result = await graphql.localAgentAssignedToCourt(parseInt(sync.ccfg_id));
         if (result.localAgentAssignedToCourt) {
            setHasLocalAgent(true);
         } else {
            setHasLocalAgent(false);
            return;
         }

         // console.log('match.mid: ', match.mid); // DON'T DELETE THIS LINE
         // console.log('sync.ccfg_id: ', sync.ccfg_id); // DON'T DELETE THIS LINE

         if (isValidMid(match?.mid)) {
            setQrMatchId(app_state.match_id);
            setQrDetails(buildReplayQrDetails(match.mid, sync.ccfg_id));
            return;
         }

         await new Promise(resolve => setTimeout(resolve, MID_RETRY_INTERVAL_MS));
      }
   }


   const editMatchBtn = () => {
      NAV_CONTROL.openMainMenu();
      NAV_CONTROL.openMainMenuEdit();
   }

   useEffect(() => {
      load_match();

      if (!isVisible) {
         reset_qr_details();
         return;
      }

      get_qr_details();

      return () => {
         qrFetchCancelledRef.current = true;
      };
   }, [visibility, isVisible]);


   useEffect(() => {
      NAV_CONTROL.appendCallback('warmup_block', () => {
         load_match(true);
         get_qr_details();
      });
      return () => {
         // >>> Runs on unLoad (Unload runs first if component is already mounted)
      };
   }, []); // >> [] -- Monitor




   return (
      <Overlay visibility={visibility} ref={wrapper}>
         <div className={isLandscape ? style.wrap : style.wrapPortrait} style={GLOBAL_CSS.background} >
            <div className={style.head}> Warm-up </div>
            <div className={style.body}>
               <div className={style.matchSettings}>
                  <h3>Match Settings</h3>
                  {sportSettings.map((item) => {
                     let value = item.value;
                     if (item.type === 'radio') {
                        const index = item.options.findIndex(x => x.value === item.value);
                        if (index !== -1) {
                           value = item.options[index].label;
                        }
                     }
                     if (item.value !== '') {
                        return (<p key={genKeyRan(item.label)} > <b>{item.label}</b> {value} </p>)
                     }
                  })}

                  {!is_push_match() ? (<button className={style.editBtn} onClick={editMatchBtn}> Is this Correct? Click here to change it NOW! </button>) : null}

               </div>
               <div className={style.centerBlock}>
                  <div className={style.centerBlock_Space}>
                     <Clock settings={Props.warmupTimer} ></Clock>
                  </div>
                  <ScoreToolBlock extraClass={style.btnSpace} btnList={btnList} ></ScoreToolBlock>

                  <div className={style.centerBlock_Space}>
                     {/* <div className={style.qrCodeSpace}>
                        {qrDetails ? (
                           <QrCodeTool
                              key={`${qrMatchId}-${qrDetails.params.mid}`}
                              payloadType="json"
                              value={qrDetails}
                              size={200}
                              margin={1}
                              showDownloadButton={false}
                           />
                        ) : (
                           <div className={style.qrLoading}>
                              <FontAwesomeIcon icon={faSpinner} spin />
                           </div>
                        )}
                     </div> */}
                  </div>
               </div>

               {hasLocalAgent ? (
                  <div className={style.qrCodeSpace}>
                     {qrDetails ? (
                        <>
                           <QrCodeTool
                              key={`${qrMatchId}-${qrDetails.params.mid}`}
                              payloadType="json"
                              value={qrDetails}
                              size={200}
                              margin={1}
                              showDownloadButton={false}
                           />
                           <p>Scan using SME Live App for Instant Replay recordings</p>
                        </>
                     ) : (
                        <div className={style.qrLoading}>
                           <FontAwesomeIcon icon={faSpinner} spin />
                        </div>
                     )}
                  </div>
               ) : (
                  <div className={style.addBlock}>
                     <AdImage></AdImage>
                  </div>
               )}

            </div>
         </div>
      </Overlay>
   );
}

export default WarmUpBlock;